import React from 'react';
import WIDGET_VERSION from 'trade-in-360/constants/widgetVersions.js';

const NewTradeInContext = React.createContext({
    useCBB: false,
    skipEstimate: false,
    version: WIDGET_VERSION.TRADE_360, // default value
    isTradeInAppointment: false,
    fieldsLocked: false,
    isOfficialTradeIn: false,
    isLoginModalOpen: false,
    isNewRequest: false,
    isModified: false, // indicates if user has interacted with the widget (show a quit confirmation modal accordingly)
    officialEdit: false, // indicates if we allow editing during official view
    setIsLoginModalOpen: () => {},
    setFieldsLocked: () => {},
    setIsOfficialTradeIn: () => {},
    setNewRequest: () => {},
    setIsModified: () => {},
    setOfficialEdit: () => {},
});

export const NewTradeInProvider = NewTradeInContext.Provider;
export const NewTradeInConsumer = NewTradeInContext.Consumer;

export default NewTradeInContext;
